export enum DiscountLogic {
  Unknown = 'unknown',
  Absolute = 'absolute',
  Relative = 'relative'
}

export enum AndOrLogic {
  and = 'and',
  or = 'or'
}

export enum DiscountType {
  Unknown = 'unknown',
  Product = 'product',
  GiftItem = 'gift',
  BuyMoreSaveMore = 'buy_more_save_more',
  ProductGroup = 'bundle',
  Coupon = 'coupon',
  Credit = 'credit'
}

export enum BMSMVariant {
  Unknown = 'unknown',
  Products = 'products',
  CartValue = 'cart_value'
}

export enum CouponDiscountType {
  cart,
  product,
  discount
}

export enum CouponType {
  manual,
  discount
}
